// TODO: Deprecate this file in favor of./creationTool/oeqSagas
// where oeq is independent from the presentation entity
// and uses the new microservices architecture

import { takeLatest, takeEvery } from 'redux-saga'
import { put, fork, take, cancel, select, race, call } from 'redux-saga/effects'
import actionTypes from 'redux/actions/actionTypes'
import callAny from './helpers/call_any'
import { oeqSync, pollSync, iconSync, slideSync } from 'sync'
import { localize } from 'helpers/translator'
import oeqActions from 'redux/actions/oeqActions'
import oeqQuestionSelector from 'redux/selectors/oeq/oeq_question_selector'
import oeqValidationSelector from 'redux/selectors/oeq/oeq_validation_selector'
import oeqSaveSelector from 'redux/selectors/oeq/oeq_save_selector'
import oeqCancelSelector from 'redux/selectors/oeq/oeq_cancel_selector'
import oeqTimerSelector from 'redux/selectors/oeq/oeq_timer_selector'
import fileUploader from 'helpers/fileUploader'
import iconTypes from 'helpers/enums/iconTypes'
import errorCodes from 'helpers/enums/errorCodes'
import formatError from './helpers/error_formatter'

function *oeqDeleteReferenceMedia() {
	try {
		const questionSelector = yield select(oeqQuestionSelector)
		if (questionSelector.icon.status === 'uploading') {
			yield callAny(iconSync.cancelUpload, questionSelector.icon.uploadId)
		}
		// TODO: test this specific case
		yield call(oeqCreateUpdateQuestion)

	} catch (error) {
		// TODO: Explain why this error needs to be swallowed
	}
}

function *oeqCreateInitialize(action) {
	if (!action.oeqUID) {
		return
	}
	try {
		const response = yield callAny(
			oeqSync.getOEQ,
			action.oeqUID,
			action.jwt,
		)
		yield put(oeqActions.initializeOEQSuccess(response.payload.poll))
	} catch (error) {
		yield put(oeqActions.initializeOEQError())
	}
}

function *oeqSave() {
	const successActions = [
		actionTypes.OEQ_SAVE_OEQ_SUCCESS,
		actionTypes.OEQ_QUESTION_UPDATE_SUCCESS,
		actionTypes.OEQ_UPLOADER_UPLOAD_SUCCESS,
	]
	const errorActions = [
		actionTypes.OEQ_UPLOADER_VALIDATE_ERROR,
		actionTypes.OEQ_UPLOAD_REFERENCE_MEDIA_ERROR,
		actionTypes.OEQ_UPLOADER_UPLOAD_ERROR,
		actionTypes.OEQ_UPLOADER_VALIDATE_CONTENT_ERROR,
		actionTypes.OEQ_QUESTION_UPDATE_ERROR,
	]
	let saveSelector
	try {
		const validationSelector = yield select(oeqValidationSelector)
		if (validationSelector.valid) {
			saveSelector = yield select(oeqSaveSelector)
			yield put(
				oeqActions.validationSuccess(
					saveSelector.allIconsDone ? null : localize('oeq_will_save_after_uploading'),
				)
			)
			let allRequestsDone = false

			//if there is a question changed at this point perform update
			const oeqQuestion = yield select(oeqQuestionSelector)
			if (oeqQuestion.status === 'changed') {
				yield put(oeqActions.questionSave())
			}

			while (!allRequestsDone) {
				saveSelector = yield select(oeqSaveSelector)
				allRequestsDone =
					saveSelector.allQuestionsDone
					&& saveSelector.allIconsDone

				if (allRequestsDone) {
					const response = yield callAny(
						pollSync.savePoll,
						saveSelector.entityUID,
						saveSelector.studentRecordingAudioEnabled,
						saveSelector.allowPublishWithoutThumbnail,
					)
					yield put(
						oeqActions.saveOEQSuccess(
							response.payload.redirectUrl,
							response.payload.metrics,
						)
					)
				} else {
					const requestActions = yield take(
						[
							...successActions,
							...errorActions,
						],
					)
					if (errorActions.includes(requestActions.type)) {
						allRequestsDone = true
						throw requestActions.error || new Error('Save Undefined Error')
					}
				}
			}
		} else {
			yield put(oeqActions.validationError(validationSelector.message))
		}
	} catch (error) {
		yield put(oeqActions.saveOEQError(error))
	}
}

function *oeqCreateUpdateQuestion() {
	try {
		const questionSelector = yield select(oeqQuestionSelector)
		yield callAny(
			pollSync.updateQuestion,
			questionSelector.text,
			questionSelector.entityUID,
			questionSelector.icon.id,
			questionSelector.answers,
		)
		yield put(oeqActions.questionUpdateSuccess())
	} catch (error) {
		const serverError = formatError(error)
		yield put(oeqActions.questionUpdateError(serverError))
	}
}


function *oeqTakeLatestCreateUpdateQuestion() {
	//this is a customized take latest for updating questions
	//to avoid server concurrency we use the delay
	//and to avoid missing updates for different questions,
	//we compare the last one with the previous one
	let previousFork = null
	let action
	while (true) {
		action = yield take([actionTypes.OEQ_QUESTION_SAVE])
		if (previousFork !== null) {
			yield cancel(previousFork)
		}
		previousFork = yield fork(oeqCreateUpdateQuestion, action)
	}
}

function *oeqUploadReferenceMedia(action) {
	try {
		let questionSelector = yield select(oeqQuestionSelector)
		const validateResponse = yield callAny(
			iconSync.validateFilesPicked,
			action.allowedTypes,
			action.files['files'],
			questionSelector.presentationId,
			questionSelector.entityUID,
			action.force,
		)
		const payload = validateResponse.payload.icons[0]
		const file = action.files['files'][0]
		if (payload.error_code === 0) {
			yield put(oeqActions.uploaderValidateSuccess(payload.uploadId))
			questionSelector = yield select(oeqQuestionSelector)
			const {uploadResponse} = yield race({
				questionOrIconDeleted: take(actionTypes.OEQ_DELETE_REFERENCE_MEDIA),
				uploadResponse: callAny(
					fileUploader,
					payload.uploadId,
					file,
					'Question',
					questionSelector.serverId,
					iconTypes.ENTITY_ICON_TYPE_REFERENCE_MEDIA,
					action.allowedTypes,
					questionSelector.presentationId,
					questionSelector.entityUID,
					action.force,
				),
			})
			if (uploadResponse) {
				yield put(
					oeqActions.uploaderUploadSuccess(
						uploadResponse.payload.icon,
					)
				)
			}
		} else {
			// webpage content validation
			if (payload.error_code === errorCodes.ICON_INVALID_CONTENT_INTEGRITY) {
				yield put(oeqActions.uploaderValidateContentError(payload.message))
				yield take(actionTypes.OEQ_UPLOAD_REQUIRE_CONFIRMATION)
				yield put(oeqActions.uploadReferenceMedia(
					action.allowedTypes,
					action.files,
					action.featureType,
					true,
				))
			} else {
				yield put(oeqActions.uploaderValidateError(payload.message))
			}
		}
	} catch (error) {
		let message = localize('quiz_service_error_message')
		if (error.serverError && error.serverError.message) {
			message = error.serverError.message
		}
		yield put(oeqActions.uploaderUploadError(error.serverError, message))
	}
}

function *oeqCancelChanges() {
	const cancelSelector = yield select(oeqCancelSelector)
	if (cancelSelector.isModified) {
		yield put(oeqActions.cancelOEQConfirm())
	} else {
		yield put(oeqActions.cancelOEQConfirmed())
	}
}

function *timerSave(action) {
	try {
		const { timerValue, entityUID } = yield select(oeqTimerSelector)
		yield callAny(slideSync.saveTimer, timerValue, entityUID)
		yield put({
			type: actionTypes.OEQ_TIMER_SAVE_SUCCESS,
		})
	} catch (error) {
		yield put(oeqActions.saveTimerError(action.previous_timer))
	}
}

export default [
	takeLatest([
		actionTypes.OEQ_INITIALIZE_CREATION_TOOL,
		actionTypes.OEQ_SCREENSHOT_INITIALIZE_ROUTE,
		actionTypes.OEQ_INITIALIZE_STANDALONE,
		actionTypes.QUICK_LAUNCH_OEQ_INITIALIZE_CREATION_TOOL,
		actionTypes.QUICK_LAUNCH_OEQ_CREATE_LESSON_SUCCESS,
	], oeqCreateInitialize),
	takeLatest(actionTypes.OEQ_SAVE_OEQ, oeqSave),
	fork(oeqTakeLatestCreateUpdateQuestion),
	takeEvery(actionTypes.OEQ_UPLOAD_REFERENCE_MEDIA, oeqUploadReferenceMedia),
	takeLatest([
		actionTypes.OEQ_DELETE_REFERENCE_MEDIA,
		actionTypes.OEQ_AUDIO_PLAYER_DELETE_CONFIRMED,
	], oeqDeleteReferenceMedia),
	takeLatest(actionTypes.OEQ_CANCEL_OEQ, oeqCancelChanges),
	takeLatest([
		actionTypes.OEQ_SAVE_TIMER,
		actionTypes.OEQ_DELETE_TIMER,
	], timerSave),
]

export {
	oeqCreateInitialize,
}
